import GATSBY_COMPILED_MDX from "/home/runner/work/kararyli.net/kararyli.net/src/content/posts/2006-05-12-net-neutrality-moveon-told-us-to-unite.md";
import React from "react";
import DisclaimerSnippet from "../content/snippets/pre-transition-disclaimer.md";
import * as classNames from "./PostPage.module.css";
import AdjacentPostButton, {Direction} from "../components/AdjacentPostButton";
import Header from "../components/Header";
import MarkdownContent from "../components/MarkdownContent";
import Monogram from "../components/Monogram";
import {Author, UNTITLED} from "../graphql";
import {humanReadableDate} from "../util/dates";
import MetaElements, {OGAudio, OGType} from "./MetaElements";
import PostMedia from "./PostMedia";
const PostPage = _ref => {
  let {pageContext, children} = _ref;
  const {frontmatter: {date, title = UNTITLED, author = Author.Ryan, media}} = pageContext.post;
  let subtitle = "";
  if (date) {
    subtitle = `Published ${humanReadableDate(date)}`;
  }
  return React.createElement(React.Fragment, null, React.createElement(Header, {
    title: title,
    subtitle: subtitle
  }), author !== Author.Kara && React.createElement(MarkdownContent, {
    className: classNames.disclaimer
  }, React.createElement(DisclaimerSnippet, null)), media && React.createElement(PostMedia, {
    media: media
  }), React.createElement(MarkdownContent, {
    dropcap: true
  }, children), React.createElement(Monogram, {
    footer: true
  }), React.createElement(AdjacentPostButton, {
    direction: Direction.PREVIOUS,
    post: pageContext.previous
  }), React.createElement(AdjacentPostButton, {
    direction: Direction.NEXT,
    post: pageContext.next
  }));
};
export const Head = _ref2 => {
  let {children, pageContext} = _ref2;
  const {frontmatter: {date, title = UNTITLED, image, media}, excerpt = ""} = pageContext.post;
  return React.createElement(MetaElements, {
    title: title,
    description: excerpt,
    image: image !== null && image !== void 0 ? image : media === null || media === void 0 ? void 0 : media.image,
    type: OGType.Article,
    published: date
  }, media && React.createElement(OGAudio, {
    url: media.url
  }), children);
};
PostPage
export default function GatsbyMDXWrapper(props) {
  return React.createElement(PostPage, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
